"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _root = _interopRequireDefault(require("./style/root"));

var _title = _interopRequireDefault(require("./style/title"));

var _titleWrapper = _interopRequireDefault(require("./style/titleWrapper"));

var _icon = _interopRequireDefault(require("./style/icon"));

var _description = _interopRequireDefault(require("./style/description"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var ModuleTitle = function ModuleTitle(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      theme = _ref.theme,
      style = _ref.style;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  return _react["default"].createElement(_root["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_titleWrapper["default"], {
    theme: memoTheme
  }, icon ? _react["default"].createElement(_icon["default"], {
    theme: memoTheme
  }, icon) : null, _react["default"].createElement("div", null, _react["default"].createElement(_title["default"], {
    theme: memoTheme
  }, title), _react["default"].createElement(_description["default"], {
    theme: memoTheme
  }, description))), children);
};

ModuleTitle.propTypes = {
  children: _propTypes["default"].any,
  icon: _propTypes["default"].any,
  title: _propTypes["default"].any,
  description: _propTypes["default"].any,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsLarge
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlLarge
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.twSemi
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tInactive
     */
    descriptionColor: _propTypes["default"].string,

    /**
     * @default palette.tsSmall
     */
    descriptionFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlSmall
     */
    descriptionLineHeight: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 4 + 'px'
     */
    iconMarginRight: _propTypes["default"].string
  })
};
ModuleTitle.displayName = 'ModuleTitle';
var _default = ModuleTitle;
exports["default"] = _default;